import { render, staticRenderFns } from "./UploadImgOnly.vue?vue&type=template&id=20f1fb5a&scoped=true"
import script from "./UploadImgOnly.vue?vue&type=script&lang=js"
export * from "./UploadImgOnly.vue?vue&type=script&lang=js"
import style0 from "./UploadImgOnly.vue?vue&type=style&index=0&id=20f1fb5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f1fb5a",
  null
  
)

export default component.exports